import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class Omnibus extends Component {
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  #handleVariantUpdate = (event) => {
    const variantId = event.detail.resource?.id;
    if (!variantId) return;

    const items = this.querySelectorAll('.omnibus__item');
    items.forEach((item) => {
      item.style.display = item.dataset.variantId === String(variantId) ? 'block' : 'none';
    });
  };
}

if (!customElements.get('omnibus-price')) {
  customElements.define('omnibus-price', Omnibus);
}
